import {handleActions} from 'redux-actions'
import * as ActionTypes from './actionTypes'

const initialState = {
    messages: []
}

const toasts = handleActions({
    [ActionTypes.MESSAGES_SET]: (state, {payload: messages}) => ({...state, messages}),
}, initialState)

export default toasts



// WEBPACK FOOTER //
// ./web/js/toasts/reducer.js